import Vue from 'vue';

import {
  formatNumber,
  alignForNumber,
  autoResize,
  LinkCellRenderer,
} from '@/helpers/renderHelpers';
import { handlerResponse } from '@/helpers/commonHelpers'

export default {
  namespaced: true,
  state: {
    columns: [
      {field: "group", colId: "group", headerName: "", checkboxSelection: true},
      {field: 'filename', colId: "filename", headerName: 'File'},
      {field: 'type', colId: "type", headerName: 'Type'}],
    gridOptions: {
      animateRows: true,
      rowSelection: 'single',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true
      },
      onRowDataChanged() {
        if (this.rowData && this.rowData.length) {
          autoResize(this);
        }
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/general/documents/generalDocuments.js